import React from 'react';
import vgpro from 'assets/images/vgpro.png';

import { Title, Logo, Highlight } from './styles';

// const BrandTitle = () => (
//   <Title>
//     Value Guide
//     <Highlight> Pro</Highlight>
//   </Title>
// );

const BrandTitle = () => <Logo src={vgpro} />

export default BrandTitle;
